<template>
  <div>
    <b-alert
      v-if="message && type==='success'"
      show
      variant="success"
    >
      {{ message }}
    </b-alert>
    <b-alert
      v-if="message && type==='error'"
      show
      variant="danger"
    >
      {{ message }}
    </b-alert>
  </div>        
</template>

<script>

import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('flashMessage', ['message', 'type'])
  },
}
</script>
